export default "__VITE_ASSET__BlOtVpIw__"